import { render, staticRenderFns } from "./WizardTabs.vue?vue&type=template&id=067c88d8&"
import script from "./WizardTabs.vue?vue&type=script&lang=ts&"
export * from "./WizardTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports